export default __webpack_public_path__ + "static/media/26f49824379c1c46.a9674a7414a2cd9bf01bff815629a95c.svg";